import { render, staticRenderFns } from "./TermSignature.vue?vue&type=template&id=62f8fc9c"
import script from "./TermSignature.vue?vue&type=script&lang=js"
export * from "./TermSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f8fc9c')) {
      api.createRecord('62f8fc9c', component.options)
    } else {
      api.reload('62f8fc9c', component.options)
    }
    module.hot.accept("./TermSignature.vue?vue&type=template&id=62f8fc9c", function () {
      api.rerender('62f8fc9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/TermSignature.vue"
export default component.exports